import {
	observer
} from 'mobx-react';
import {
	WeaTableNew,
} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;

@observer
export default class Table extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			tableProps,
			tableStore,
			onOperatesClick,
			reRenderColumns,
			scroll,
			onRowClick,
		} = store;
		
		if (onRowClick) {
			tableProps.onRowClick = onRowClick
		}
		if (scroll) {
			tableProps.scroll = scroll;
		}

		return (
			<WeaTable ecId={`${this && this.props && this.props.ecId || ''}_WeaTable@oh5gdz`} 
				{...tableProps}
				comsWeaTableStore={tableStore}
				onOperatesClick={(record,index,operate,flag)=>onOperatesClick(record,index,operate,flag)}
				getColumns={columns=>reRenderColumns(columns)}
			/>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4backstage/hrmengine/public/valhalla/components/Table.js